/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SaveRiskEvalReviewRequestBody,
  SaveRiskEvalReviewRequestBody$Outbound,
  SaveRiskEvalReviewRequestBody$outboundSchema,
} from "../components/saveriskevalreviewrequestbody.js";

export type SaveRiskEvalReviewSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SaveRiskEvalReviewSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SaveRiskEvalReviewSecurity = {
  option1?: SaveRiskEvalReviewSecurityOption1 | undefined;
  option2?: SaveRiskEvalReviewSecurityOption2 | undefined;
};

export type SaveRiskEvalReviewRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  saveRiskEvalReviewRequestBody: SaveRiskEvalReviewRequestBody;
};

/** @internal */
export type SaveRiskEvalReviewSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SaveRiskEvalReviewSecurityOption1$outboundSchema: z.ZodMiniType<
  SaveRiskEvalReviewSecurityOption1$Outbound,
  SaveRiskEvalReviewSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function saveRiskEvalReviewSecurityOption1ToJSON(
  saveRiskEvalReviewSecurityOption1: SaveRiskEvalReviewSecurityOption1,
): string {
  return JSON.stringify(
    SaveRiskEvalReviewSecurityOption1$outboundSchema.parse(
      saveRiskEvalReviewSecurityOption1,
    ),
  );
}

/** @internal */
export type SaveRiskEvalReviewSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SaveRiskEvalReviewSecurityOption2$outboundSchema: z.ZodMiniType<
  SaveRiskEvalReviewSecurityOption2$Outbound,
  SaveRiskEvalReviewSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function saveRiskEvalReviewSecurityOption2ToJSON(
  saveRiskEvalReviewSecurityOption2: SaveRiskEvalReviewSecurityOption2,
): string {
  return JSON.stringify(
    SaveRiskEvalReviewSecurityOption2$outboundSchema.parse(
      saveRiskEvalReviewSecurityOption2,
    ),
  );
}

/** @internal */
export type SaveRiskEvalReviewSecurity$Outbound = {
  Option1?: SaveRiskEvalReviewSecurityOption1$Outbound | undefined;
  Option2?: SaveRiskEvalReviewSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SaveRiskEvalReviewSecurity$outboundSchema: z.ZodMiniType<
  SaveRiskEvalReviewSecurity$Outbound,
  SaveRiskEvalReviewSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SaveRiskEvalReviewSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SaveRiskEvalReviewSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function saveRiskEvalReviewSecurityToJSON(
  saveRiskEvalReviewSecurity: SaveRiskEvalReviewSecurity,
): string {
  return JSON.stringify(
    SaveRiskEvalReviewSecurity$outboundSchema.parse(saveRiskEvalReviewSecurity),
  );
}

/** @internal */
export type SaveRiskEvalReviewRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SaveRiskEvalReviewRequestBody: SaveRiskEvalReviewRequestBody$Outbound;
};

/** @internal */
export const SaveRiskEvalReviewRequest$outboundSchema: z.ZodMiniType<
  SaveRiskEvalReviewRequest$Outbound,
  SaveRiskEvalReviewRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    saveRiskEvalReviewRequestBody: SaveRiskEvalReviewRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      saveRiskEvalReviewRequestBody: "SaveRiskEvalReviewRequestBody",
    });
  }),
);

export function saveRiskEvalReviewRequestToJSON(
  saveRiskEvalReviewRequest: SaveRiskEvalReviewRequest,
): string {
  return JSON.stringify(
    SaveRiskEvalReviewRequest$outboundSchema.parse(saveRiskEvalReviewRequest),
  );
}
